var React = require('react');

function Icon (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M16.9999 0.333252C7.83325 0.333252 0.333252 7.83325 0.333252 16.9999C0.333252 26.1666 7.83325 33.6666 16.9999 33.6666C26.1666 33.6666 33.6666 26.1666 33.6666 16.9999C33.6666 7.83325 26.1666 0.333252 16.9999 0.333252ZM22.9166 23.3333L16.1166 19.1499C15.6166 18.8499 15.3166 18.3166 15.3166 17.7333V9.91659C15.3333 9.23325 15.8999 8.66659 16.5833 8.66659C17.2666 8.66659 17.8333 9.23325 17.8333 9.91659V17.3333L24.2333 21.1833C24.8333 21.5499 25.0333 22.3333 24.6666 22.9333C24.2999 23.5166 23.5166 23.6999 22.9166 23.3333Z","fill":"white"}));
}

Icon.defaultProps = {"width":"34","height":"34","viewBox":"0 0 34 34","fill":"none"};

module.exports = Icon;

Icon.default = Icon;
